import { render } from "./GameEndNotification.vue?vue&type=template&id=7656a5d4&scoped=true"
import script from "./GameEndNotification.vue?vue&type=script&lang=js"
export * from "./GameEndNotification.vue?vue&type=script&lang=js"

import "./GameEndNotification.vue?vue&type=style&index=0&id=7656a5d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7656a5d4"]])

export default __exports__